// extracted by mini-css-extract-plugin
module.exports = {"side_links":"SideLinks_side_links__7_hxn"};